
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'   // eslint-disable-line
import RemoveReporter from './removeReporter.vue'
import UploadImg from '@/components/upload_img/index.vue'
import { IMG_HOST } from '@/config/env'
import { ReporterService, MediaService } from '@/services/index'
import { AppModule } from '@/store/modules/app'
import { convertCodeToText, convertTextToCode } from '@/common/area_data'

@Component({
    name: 'Details',
    components: {
        UploadImg,
        RemoveReporter
    }
})
export default class extends Vue {
    @Prop({ required: true }) private reporter!: any 
    private detailsForm: any = {
        avatar: '',
        gender: '',
        pen_name: '',
        meet_at: '',
        work_at: '',
        department: '',
        post: '',
        mobile: '',
        wechat: '',
        email: '',
        qq: '',
        city: '',
        birthday: '',
        children: '',
        hobby: '',
        character: '',
        id_card_code: '',
        address: '',
        note: '',
        mediaName: '',
        name: '',
        custom_memos: [],
        intro: '',
        type: ''
    }
    private detailsRules = {
        name: [
            { required: true, message: '请输入记者名称', trigger: 'blur' },
            { min: 2, max: 10, message: '记者名称长度为2~10位', trigger: 'blur' }
        ],
        mediaName: [
            { required: true, message: '请输入供职媒体', trigger: 'blur' },
            { min: 2, max: 100, message: '供职媒体长度为2~100位', trigger: 'blur' }
        ],
        avatar: [
            { required: true, message: '请上传头像', trigger: 'blur' }
        ],
        intro: [
            { min: 2, max: 500, message: '个人简介长度为2~500位', trigger: 'blur' }
        ]
    }
    private isUpdateLoading = false
    private customRemarkName: string = ''
    private visible: boolean = false
    private IMG_HOST = IMG_HOST
    private genderOptions = [{
        value: 1,
        label: '男'
    }, {
        value: 0,
        label: '女'
    }]
    get $infoForm() {
        return this.$refs.infoForm as ElForm
    }

    get provinceAndCityData() {
        return AppModule.provinceAndCity
    }

    /* ---------------------- 分界线 ---------------------- */

    private mounted() {
        // 使用定时器是为了，让地址赋值成功，先走异步
        setTimeout(() => {
            const region = [this.reporter.province, this.reporter.city]
            this.detailsForm = Object.assign(this.detailsForm, this.reporter, {
                id: this.reporter.id,
                name: this.reporter.name,
                mediaName: this.reporter.media.name,
                media: this.reporter.media,
                avatar: this.reporter.avatar.replace(IMG_HOST, ''),
                intro: this.reporter.intro,
                region: convertTextToCode(region)
            })
        })
    }

    private async onSubmit() {
        this.$infoForm.validate(async(valid: boolean) => {
            if (valid) {
                this.isUpdateLoading = true
                const media: any = 
                    this.detailsForm.media.name 
                    && this.detailsForm.media.name === this.detailsForm.mediaName 
                        ? this.detailsForm.media : { id: '', name: this.detailsForm.mediaName }
                const params = this.detailsForm
                const [province, city] = convertCodeToText(this.detailsForm.region).split(',')
                Object.assign(params, { 
                    media, 
                    province,
                    city
                })
                this.isUpdateLoading = true
                const result = await ReporterService.update(params)
                this.isUpdateLoading = false
                if (result.status === 200) {
                    return this.$message.success('更新成功')
                }
                return this.$message.error(result.message || '更新失败')
            } else {
                return false
            }
        })
    }

    private onAddRemark() {
        this.detailsForm.custom_memos.push({ name: this.customRemarkName, content: '' })
        this.customRemarkName = ''
        this.visible = false
    }

    private uploadCallback(url: string) {
        this.detailsForm.avatar = url
        this.$infoForm.validateField('avatar')
    }

    private onRemoveRemark(index: number) {
        this.detailsForm.custom_memos.splice(index, 1)
    }
    private async getMedias(queryString: string, cb: Function) {
        if (queryString) {
            const result = await MediaService.searchMedia({ value: queryString })
            if (result.status === 200) {
                const medias = result.data.map((
                    media: { id: number, name: string }
                ) => {
                    return {
                        id: media.id,
                        value: media.name
                    }
                })
                cb(medias)
            }
        } else {
            cb([])
        }
    }

    private onSelectMedia(media: any) {
        this.detailsForm.media = { id: media.id, name: media.value }
        this.$infoForm.validateField('mediaName')
    }

    private onSelectRegion(value: any) {
        this.detailsForm.region = value
    }

    private onRemove() {
        this.$confirm('确认删除此记者?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            (this.$refs.removeReporter as any).show(this.reporter, () => {
                this.$router.push({ name: 'ReporterList' })
            })
        }).catch(() => {
            this.$message({ type: 'info', message: '已取消操作' })         
        })
    }
}
